import { type CustomField } from 'entities/CustomField/model'
import { CustomFieldModalStore } from 'entities/CustomField/ui/CustomFieldModal/store/CustomFieldModalStore'

export const createCustomFieldPromise = (): Promise<CustomField | null> =>
  new Promise((resolve) => {
    new CustomFieldModalStore({
      onCreated: (field) => resolve(field),
      onClose: () => resolve(null),
    })
  })
